module.exports = __webpack_public_path__ + "img/sieckFinesseSetup1.35e593af.png";